export * from './bds-origin-criteria.module';
export { BdsOriginCriteriaDialogComponent } from './bds-origin-criteria-dialog/bds-origin-criteria-dialog.component';
export { BdsOriginCriteriaDialogModel } from './models/bds-origin-criteria-dialog.model';
export {
    BdsOriginCriteriaService,
    BdsOriginCriteriaApiServiceOptions,
} from './bds-origin-criteria.service';
